import { Route, Switch, Redirect } from 'react-router-dom';
import asyncComponent from '../../itrust_common/components/AsyncComponent';

// const Dashboard = asyncComponent(() =>
//   import('../../containers/authorised/dashboard/Dashboard.js')
// );

const DemoRequest = asyncComponent(() =>
  import('../../containers/authorised/dashboard/demoRequest/DemoRequest')
)

const CallbackRequest = asyncComponent(() =>
  import('../../containers/authorised/dashboard/callbackRequest/CallbackRequest')
)

const DashboardRoutes = (
  <Switch>
    {/* <Route exact path="/dashboard" component={Dashboard} /> */}
    <Route exact path="/dashboard/demo-requests" component={DemoRequest} />
    <Route exact path="/dashboard/callback-requests" component={CallbackRequest} />
    <Redirect exact from="/dashboard" to="/dashboard/demo-requests" />
    <Redirect exact from="/" to="/dashboard/demo-requests" />
  </Switch>
);

export default DashboardRoutes;